import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShareMapComponent } from './share-map/share-map.component';
import { SharedAdminLayerComponent } from './shared-admin-layer/shared-admin-layer.component';
import { BusinessUserDashboardComponent } from './business-user-dashboard/business-user-dashboard.component';
import { MapPreviewComponent } from './map-preview/map-preview.component';


const routes: Routes = [

  {
    path: ':share_map_id/:share-Type/ok',
    component: MapPreviewComponent,
    data : {
      title:'Share-Map | MAPOG'
    }
  },
  {
    path: ':map_title/:share_map_id',
    component: ShareMapComponent,
    data : {
      title:'Share-Map | MAPOG'
    }
  },
  {
    path: ':share_map_id',
    component: MapPreviewComponent,
    data : {
      title:'Share Map | MAPOG'
    }
  },
  {
    path: 'export-layer/:layer_name/:layerid',
    component: SharedAdminLayerComponent,
    data : {
      title:'MAPOG'
    }
  },
  {
    path: ':map_title/:share_map_id/:layerid/:gid',
    component: ShareMapComponent,
    data : {
      title:'MAPOG'
    }
  },
  {
    path: 'business-dashboard',
    component: BusinessUserDashboardComponent,
    data : {
      title:'MAPOG'
    }
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppShareMapRoutingModule { }
